import { resetCookie, setCookie } from '../../lib/cookies'
import CookieOptionsView from './OptionsView'

addEventListener('DOMContentLoaded', () => {
    const cookieBar = document.querySelector('#cookie-bar')
    if (!cookieBar) return

    new CookieBar(cookieBar)
})


class CookieBar {

    constructor(element) {
        this.element = element

        this.acceptButton = this.element.querySelector('#cookie-accept-all')
        this.acceptSelectionButton = this.element.querySelector('#cookie-accept-selection')
        this.declineButton = this.element.querySelector('#cookie-denied')
        this.advancedOptions = this.element.querySelector('#advanced-options')
        this.advancedOptionsView = this.element.querySelector('div.advanced-options')

        const optButton = this.element.querySelector('#advanced-options')
        const optView = this.element.querySelector('div.advanced-options')

        new CookieOptionsView(optView, optButton, this)

        const confirm = (value) => {
            this.element.parentNode.removeChild(this.element)
            setCookie('c_enabled', value, 30)
        }

        this.acceptButton.addEventListener('click', () => {
            const values = this.getOptionValues(false)
            confirm(values.join(','))
        })

        this.acceptSelectionButton.addEventListener('click', () => {
            const checkedValues = this.getOptionValues(true)
            confirm(checkedValues.join(','))
        })

        this.declineButton.addEventListener('click', () => {
            confirm(false)
        })

        // reset the validation timer of set cookie
        resetCookie('c_enabled', 30)
    }

    getOptionValues(filterChecked = true) {
        return (this.options || [])
            .filter(option => !filterChecked || option.element.classList.contains('checked'))
            .map(option => option.checkbox.id)
    }
}
